import {Component} from '@angular/core';
import {NEVER, Observable, of, throwError} from 'rxjs';

import {RuntimeCapabilities, RuntimeCapabilitiesService} from '../../../../services/enrich/runtime-capabilities.service';
import {EnrichRuntimeStatusComponent} from '../runtime-status.component';

const fixtureRuntime = (readiness: RuntimeCapabilities['readiness']): RuntimeCapabilities => ({
  mode: 'shared-production-readonly',
  environment: 'staging',
  targetClass: 'shared-production',
  readiness,
  contractDigest: `sha256:${'c'.repeat(64)}`,
  sourceSha: 'a'.repeat(40),
  imageDigest: `sha256:${'b'.repeat(64)}`,
  capabilities: {
    customerData: false,
    mutations: false,
    routes: false,
    schedulers: false,
    workers: false,
    webhooks: false,
    hubspotRequests: false,
    providerRequests: false,
    cosmosItemReads: false,
    cosmosQueries: false,
    cosmosWrites: false,
    cosmosMetadataValidation: true,
  },
});

class RuntimeStatusVisualFixtureService {
  getRuntimeCapabilities(): Observable<RuntimeCapabilities> {
    const state = new URL(window.location.href).searchParams.get('enrichRuntimeStatusFixture') || 'ready';
    if (state === 'unavailable') return throwError(() => new Error('fixture unavailable'));
    if (state === 'loading') return NEVER;
    if (state === 'starting' || state === 'failed') return of(fixtureRuntime(state));
    return of(fixtureRuntime('ready'));
  }
}

@Component({
  selector: 'app-enrich-runtime-status-visual-fixture',
  standalone: true,
  imports: [EnrichRuntimeStatusComponent],
  providers: [{provide: RuntimeCapabilitiesService, useClass: RuntimeStatusVisualFixtureService}],
  template: '<app-enrich-runtime-status />',
})
export class RuntimeStatusVisualFixtureComponent {}
